import { computed, inject } from '@angular/core';
import { AppStore } from '@navstation-portal/reporting/data-access/app';
import {
  EngineReportCylinderUnitsVm,
  EngineReportDetailsVm,
  EngineReportState,
  EngineReportVm,
} from '@navstation-portal/reporting/data-model/engine-report';
import { SelectOption } from '@navstation-portal/shared/data-model/common';
import { VesselSpecStore } from '@navstation-portal/vessels/data-access/store';
import { MainEngine } from '@navstation-portal/vessels/data-model/vessel';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { buildCylinderUnitsVm } from './tabs/cylinder-units/cylinder-units-vm';
import { buildEngineReportDetailsVm } from './tabs/details/engine-report-details-vm-builder';

function buildMainEngineOptions(meEngines: MainEngine[] | undefined): SelectOption[] {
  return (meEngines ?? []).map((engine, index) => ({
    name: `Main Engine ${index + 1}: ${engine.make ?? ''}`.trim(),
    code: index,
  }));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withEngineReportComputed<_>() {
  return signalStoreFeature(
    type<{ state: EngineReportState }>(),
    withComputed((store) => {
      const vesselSpecStore = inject(VesselSpecStore);
      const appStore = inject(AppStore);

      return {
        vm: computed<EngineReportVm>(() => {
          const mainEngineOptions = buildMainEngineOptions(vesselSpecStore.vesselSpec()?.engine?.me_engines);

          const report = store.report();

          return {
            reportType: store.reportType(),
            localReportId: store.localReportId(),
            report,
            loadingReport: store.loadingReport(),
            reportNotFound: store.reportNotFound(),
            selectedEngineIndex: report?.details.mainEngine ?? null,
            mainEngineOptions,
            isEngineDropdownDisabled: mainEngineOptions.length <= 1,
          };
        }),
        details: computed<EngineReportDetailsVm>(() =>
          buildEngineReportDetailsVm(
            store.report()?.details,
            vesselSpecStore.vesselSpec(),
            appStore.selectedVessel()?.meReportNumber
          )
        ),
        cylinderUnits: computed<EngineReportCylinderUnitsVm>(() =>
          buildCylinderUnitsVm(
            store.report()?.cylinderUnits,
            store.report()?.details.mainEngine,
            vesselSpecStore.vesselSpec()
          )
        ),
      };
    })
  );
}
